import React from 'react';
import logoURL from '../images/logo.svg';

const Logo = ({className}) => {
  return (
    <div className={className}>
      <a href="//www.myhermes.de/" target="_blank">
        <img src={logoURL} alt="Hermes" className="header-logo__image" />
      </a>
    </div>
  )
}

export default Logo;
